import React from 'react';
import { styled } from '@mui/material/styles';

const Highlight = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
}));
const WalletAddressHighlighter = ({ address }) => {
  if (typeof address !== 'string' || address.length < 8) {
    console.error(
      'Invalid address: Address must be a string with at least 8 characters.',
    );
    return <p>Invalid address</p>;
  }

  const start = address.slice(0, 4);
  const end = address.slice(-4);
  const middle = address.slice(4, address.length - 4);

  return (
    <p>
      <Highlight>{start}</Highlight>
      {middle}
      <Highlight>{end}</Highlight>
    </p>
  );
};

export default WalletAddressHighlighter;
